import { useQuery } from "@tanstack/react-query";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

import "./event_infos.scss";
import { EventSheet, EventSheetData } from "./Event";
import { useCallback } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { DOWNLOAD_URL } from "../..";

const EventsCentre = () => {
  const events = useQuery({
    queryKey: ["events"],
    queryFn: async () => {
      return await getDocs(collection(db, "Events"));
    },
  });

  const openAppOrAppStore = useCallback((eventId: string) => {
    if (!isIOS && !isAndroid) {
      window.open(DOWNLOAD_URL);
      return;
    }

    if (!window.open(`calshare://fr.swun.calshare/event/${eventId}`)) {
      window.open(DOWNLOAD_URL);
    }
  }, []);

  return (
    <section className="part-page event-centre">
      <h1 id="title">Centre d'événements</h1>
      <ul>
        {events?.data?.docs.map((e) => (
          <EventSheet
            data={e.data() as EventSheetData}
            organisation={e.data()?.organisation}
            onClick={() => openAppOrAppStore(e.id)}
          />
        ))}
      </ul>
    </section>
  );
};

export default EventsCentre;
